import React from 'react';
import { Link as ReactLink } from 'react-router-dom';

const Link = props => {
  return <ReactLink {...props} />;
};

export default Link;
